import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import template from './template.html';

export default Vue.component('ok-map', {
  template: template,
  data: function () {
    return {
      timer: false,
      activeCategory: '',
      filterCategory: '',
      activePin: {},
      showModal: false,
      modalId: -1
    };
  },
  watch: {
    ready () {
      this.init();
    },
    '$route' (to) {
      if(to.name == 'mapModal' && to.params.modal) {
        this.openModal({gid: to.params.modal * 1});
      } else {
        this.showModal = false;
      }
    }
  },
  mounted () {
    if(this.prevRoute) {
      this.init();
    }
  },
  methods: {
    init () {
      let _this = this;
      Vue.nextTick(function () {
        _this.animateMap();
        setTimeout(function () {
          _this.handleRoute();
        }, 1000);
      });
    },
    animateMap () {
      const interval = 0.075;
      let $vm = this;
      let mapTL = new window.TimelineLite();
      let okinawa = document.getElementById('okinawa');
      let ishigaki = document.getElementById('ishigaki');
      let taketomi = document.getElementById('taketomi');
      let allPins = document.getElementsByClassName('map__pins');
      let culturePins = document.getElementsByClassName('culturePins');
      let locationsPins = document.getElementsByClassName('locationsPins');
      let foodPins = document.getElementsByClassName('foodPins');
      let naturePins = document.getElementsByClassName('naturePins');
      let groupPins = document.getElementsByClassName('groupPins');
      let bgWave = document.getElementsByClassName('map__wave');
      mapTL
        .staggerFromTo([okinawa, ishigaki, taketomi], 3, {scale: 0.85, opacity: 0, x: '+=30', y:'-=10'}, {scale: 0.9, opacity: 1}, interval*4, 'together')
        .staggerFromTo([groupPins, culturePins, locationsPins, foodPins, naturePins], 3, {y: '-=20', opacity: 0}, {y: '+=20', opacity: 1}, 0.1, 'together+=1.2');

      let yoyoX = _.random(20,40);
      let yoyoY = _.random(20,40);
      window.TweenMax.to(bgWave, interval*36*2, {x: `+=${yoyoX}`, y: `+=${yoyoY}`, opacity: '-=0.2', repeat:-1, yoyo:true, ease: window.Linear.easeNone});

      this.$store.dispatch('showNav');

      // Pin group modal location update
      window.onresize = function() {
        if($vm.activePin.target) {
          let bounds = $vm.activePin.target.getBoundingClientRect();
          $vm.activePin.x = bounds.left;
          $vm.activePin.y = bounds.top;
        }
      };

      // Pin hover animations
      _.each(allPins, function (pin) {
        window.TweenMax.set([pin], {transformOrigin:'50% 100%'});
        pin.addEventListener('mouseenter', _.debounce(function () {
          $vm.activePin = {};
          window.TweenMax.to([pin], 0.3, {scale: 1.2, ease: window.Linear.easeNone});
        }, 20));
        pin.addEventListener('mouseleave', _.debounce(function () {
          window.TweenMax.to([pin], 0.3, {scale: 1, ease: window.Linear.easeNone});
        }, 20));
      });
    },
    showGroup (group, event) {
      window.evt = event;
      let bounds = document.getElementById(`group_marker_${group.id}`).getBoundingClientRect();

      this.activePin = {
        id: group.id,
        show: true,
        bounds: bounds,
        x: bounds.left,
        y: bounds.top
      };

      window.dataLayer.push({
        'event': 'groupPinClick'
      });
    },
    playVideo (pin) {
      this.trackModal(pin);
      this.$router.push({
        name: 'videos',
        params: {
          id:pin.section.video,
          time: pin.section.time
        }
      });
    },
    setCategory (cat) {
      let $pins = $('.map__pins').not('.groupPins');
      // let $groups = $('.groupPins');

      if(cat) {
        let $hidePins = $pins.not(`.${cat}`);
        let $showPins = $pins.filter(`.${cat}`);
        window.TweenMax.set([$hidePins, $showPins], {transformOrigin:'50% 100%'});
        window.TweenMax.to($hidePins, 1, {scale: 0.5, opacity: 0, ease: window.Linear.easeOut});
        window.TweenMax.to($showPins, 1, {scale: 1, opacity: 1, ease: window.Linear.easeOut});
        this.activePin = {};
      } else {
        window.TweenMax.to($pins, 1, {scale: 1, opacity: 1, ease: window.Linear.easeOut});
      }
      this.activeCategory = cat;
      this.filterCategory = cat.split('P')[0];
    },
    toggleCategory (cat) {
      if(this.activeCategory == cat) {
        this.activeCategory = '';
      } else {
        this.activeCategory = cat;
      }
    },
    openModal (pin) {
      this.showModal = true;
      this.activePin = {};
      this.modalId = pin.gid;
      this.$router.push({ name: 'mapModal', params: { modal: pin.gid}});
      this.trackModal(pin);
    },
    closeModal: function () {
      this.showModal = false;
      this.$router.push({name:'map'});
    },
    handlePopup (pin) {
      if(pin.section) {
        this.playVideo(pin);
      } else {
        this.openModal(pin);
      }
    },
    handleRoute () {
      if(this.$route.params.modal) {
        this.openModal({gid: this.$route.params.modal * 1});
      }
    },
    getContentCategory (category) {
      return _.filter(this.content, {category_class: category});
    },
    trackModal (pin) {
      if(pin.title) {
        window.dataLayer.push({
          'event': 'pinClick',
          'name': pin.title,
          'category': pin.category,
          'type': pin.section ? 'video' : 'content'
        });
      }
    }
  },
  computed: {
    prevRoute () {
      return this.$store.state.routes.prevRoute.name;
    },
    content () {
      return this.$store.state.content.details || [];
    },
    groupMarkers () {
      return this.$store.state.content.groups || [];
    },
    filteredGroups () {
      return this.filterCategory ? _.filter(this.content, {category_class: this.filterCategory}) : this.content;
    },
    groupPins () {
      return _.groupBy(_.filter(this.filteredGroups, 'group'), 'group.id');
    },
    nonGroups () {
      return _.reject(this.content, 'group');
    },
    modals () {
      return _.reject(this.content, 'section');
    },
    videoPins () {
      return _.filter(this.nonGroups, 'section');
    },
    nonVideoPins () {
      return _.reject(this.nonGroups, 'section');
    },
    naturePins () {
      return _.filter(this.nonVideoPins, {category: 'nature'});
    },
    culturePins () {
      return _.filter(this.nonVideoPins, {category: 'culture'});
    },
    foodPins () {
      return _.filter(this.nonVideoPins, {category: 'food & drink'});
    },
    locationsPins () {
      return _.filter(this.nonVideoPins, {category: 'locations'});
    },
    videoNaturePins () {
      return _.filter(this.videoPins, {category: 'nature'});
    },
    videoCulturePins () {
      return _.filter(this.videoPins, {category: 'culture'});
    },
    videoFoodPins () {
      return _.filter(this.videoPins, {category: 'food & drink'});
    },
    videoLocationsPins () {
      return _.filter(this.videoPins, {category: 'locations'});
    },
    hasPreloaded () {
      return this.$store.state.ui.hasPreloaded;
    },
    ready () {
      if(this.content.length && this.hasPreloaded) {
        return true;
      }
      return false;
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/map/main.js